import { gql } from "@apollo/client";

// Custom song upload + analysis (quentin). Heavy per-beat data lives in
// analysis.json in B2 (fetched via analysisUrl); these ops carry only light
// metadata + the user's tuning. previewUrl/analysisUrl are short-lived
// presigned B2 GETs, resolved on read.
export const USER_SONG_FIELDS = gql`
  fragment UserSongFields on UserSong {
    id
    status
    errorNote
    title
    originalFilename
    durationMs
    tempoBpm
    tuning {
      chosenDropMs
      beatPhaseOffset
      leadBars
      mixWeight
    }
    previewUrl
    analysisUrl
  }
`;

export const REQUEST_SONG_UPLOAD = gql`
  mutation RequestSongUpload($filename: String!, $contentType: String!) {
    requestSongUpload(filename: $filename, contentType: $contentType) {
      songId
      uploadUrl
      sourceUri
    }
  }
`;

export const ANALYZE_USER_SONG = gql`
  ${USER_SONG_FIELDS}
  mutation AnalyzeUserSong($songId: ID!) {
    analyzeUserSong(songId: $songId) {
      ...UserSongFields
    }
  }
`;

export const UPDATE_USER_SONG_TUNING = gql`
  ${USER_SONG_FIELDS}
  mutation UpdateUserSongTuning($songId: ID!, $tuning: UserSongTuningInput!) {
    updateUserSongTuning(songId: $songId, tuning: $tuning) {
      ...UserSongFields
    }
  }
`;

// returns the full song so Apollo's normalized cache picks the new title up
// everywhere (library list, tune view) without a refetch
export const RENAME_USER_SONG = gql`
  ${USER_SONG_FIELDS}
  mutation RenameUserSong($songId: ID!, $title: String!) {
    renameUserSong(songId: $songId, title: $title) {
      ...UserSongFields
    }
  }
`;

// soft delete — the song just disappears from the user's library
export const DELETE_USER_SONG = gql`
  mutation DeleteUserSong($songId: ID!) {
    deleteUserSong(songId: $songId)
  }
`;

export const USER_SONG = gql`
  ${USER_SONG_FIELDS}
  query UserSong($songId: ID!) {
    userSong(songId: $songId) {
      ...UserSongFields
    }
  }
`;

export const USER_SONGS = gql`
  ${USER_SONG_FIELDS}
  query UserSongs {
    userSongs {
      ...UserSongFields
    }
  }
`;
